export default {"src":"/_next/static/media/share.c1bcda3a.svg","height":17,"width":14};